import { Component, inject, OnInit } from '@angular/core';
import { NavigationEnd, Router, RouterModule } from '@angular/router';
import { ClientOrderService, ClientPackageService, WebmoduleOrderModule } from '@webmodule-order/webmodule-order';
import { ApiModule, ContentManagementService } from '@webmodule-order/api';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { TauiBottomSheetModalComponent } from '@ngx-tailwind-ui/bottom-sheet-modal';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { filter } from 'rxjs';
import { ApiConfiguration } from '../../../../libs/api/src/lib/api-configuration';

@Component({
  imports: [RouterModule, WebmoduleOrderModule, ApiModule, TranslatePipe, TauiBottomSheetModalComponent],
  selector: 'webmodule-order-root',
  templateUrl: './app.component.html',
  standalone: true,
})
export class AppComponent implements OnInit {
  private readonly packageService = inject(ClientPackageService);
  private readonly contentManagementService = inject(ContentManagementService);
  private readonly translateService = inject(TranslateService);
  readonly uiState = inject(ClientOrderService).uiState;

  constructor(router: Router, gtmService: GoogleTagManagerService, apiConfiguration: ApiConfiguration) {
    apiConfiguration.rootUrl = API_URL;

    router.events.pipe(filter((event) => event instanceof NavigationEnd)).subscribe((event: NavigationEnd) => {
      console.log('event', event);
      gtmService.pushTag({ event: 'page', pageName: event.urlAfterRedirects }); // Add more fields as needed
    });
    this.translateService.setDefaultLang('nl');
    this.translateService.use('nl');
  }

  ngOnInit(): void {
    this.contentManagementService.getContentmanagementSectionsAskeyvalue().subscribe((contentmanagementSections) => {
      this.translateService.setTranslation('nl', contentmanagementSections, true);
    });
  }
}
